import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import InterviewSchedulingHub from "./components/InterviewSchedulingHub";
import RecruitingNextActions from "./components/RecruitingNextActions";

import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Overview from "./pages/Overview";
import Leads from "./pages/Leads";
import Activities from "./pages/Activities";
import Tasks from "./pages/Tasks";
import Jobs from "./pages/Jobs";
import Candidates from "./pages/Candidates";
import Candidate from "./pages/Candidate";
import Content from "./pages/Content.jsx";
import MessagesSequences from "./pages/MessagesSequences";
import InsightsReporting from "./pages/InsightsReporting";
import Team from "./pages/Team";
import Settings from "./pages/Settings";
import CandidatePublicSharePage from "./pages/CandidatePublicSharePage";
import ClientPortal from "./pages/ClientPortal";
import PublicSharePage from "./pages/PublicSharePage";
import FullWidthLayout from "./layouts/FullWidthLayout";
import CompaniesPage from "./pages/Clients";
import Contact from "./pages/Contact";
import UserView from "./pages/UserView";
import SidebarLayout from "./layouts/SidebarLayout";
import { Profile } from "./pages/Profile";

import SearchResults from "./pages/SearchResults";
import RequireProfileAccess from "./components/RequireProfileAccess";
import LegalDocumentPage from "./pages/LegalDocumentPage";
import AboutPage from "./pages/AboutPage";

function LegacyClientsRedirect() {
  const location = useLocation();

  return (
    <Navigate
      to={{
        pathname: "/companies",
        search: location.search,
        hash: location.hash,
      }}
      replace
      state={location.state}
    />
  );
}

function App() {
  return (
    <Router>
      <InterviewSchedulingHub />
      <RecruitingNextActions />
      <Routes>
        {/* Full Width */}
        <Route path="/" element={<FullWidthLayout><Login /></FullWidthLayout>} />
        <Route path="/login" element={<FullWidthLayout><Login /></FullWidthLayout>} />
        <Route path="/register" element={<FullWidthLayout><Register /></FullWidthLayout>} />
        <Route path="/forgot-password" element={<FullWidthLayout><ForgotPassword /></FullWidthLayout>} />
        <Route path="/reset-password" element={<FullWidthLayout><ResetPassword /></FullWidthLayout>} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy-policy" element={<FullWidthLayout><LegalDocumentPage documentType="privacy" /></FullWidthLayout>} />
        <Route path="/terms-of-service" element={<FullWidthLayout><LegalDocumentPage documentType="terms" /></FullWidthLayout>} />
        <Route path="/candidate-share/:token" element={<CandidatePublicSharePage />} />
        <Route path="/client-portal" element={<ClientPortal />} />
        <Route path="/client-portal/login" element={<ClientPortal />} />
        <Route path="/client-portal/accept" element={<ClientPortal />} />
        <Route path="/client-portal/presentations/:id" element={<ClientPortal />} />
        <Route path="/share/:token" element={<PublicSharePage />} />

        {/* Sidebar */}
        <Route element={<SidebarLayout />}>
          <Route path="/overview" element={<Overview />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/candidates" element={<Candidates />} />
          <Route path="/candidate/:id" element={<Candidate />} />
          <Route path="/content" element={<Content />} />
          <Route path="/messages-sequences" element={<MessagesSequences />} />
          <Route path="/insights-reporting" element={<InsightsReporting />} />
          <Route path="/team" element={<Team />} />
          <Route path="/team/:id" element={<UserView />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/companies" element={<CompaniesPage />} />
          <Route path="/contacts/:id" element={<Contact />} />
          <Route path="/users/:id" element={<UserView />} />
          <Route path="/recruiters/:id" element={<UserView />} />
          <Route path="/search" element={<SearchResults />} />
        </Route>
        <Route path="/clients" element={<LegacyClientsRedirect />} />

        {/* Protected Profile */}
        <Route
          path="/profile/:id"
          element={
            <RequireProfileAccess>
              <SidebarLayout><Profile /></SidebarLayout>
            </RequireProfileAccess>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
